import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {APIFeatureBetEventData} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetEventData";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {FeatureBuyTimesBetValue} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SanParsedInitData} from "../server/data/SanParsedInitData";
import {SanParsedGameData} from "../server/data/SanParsedGameData";

export class FeaturePrice {
    public wasFeatureBuy: boolean = false;
    private _featureBuyTimesBetValue: FeatureBuyTimesBetValue[] = [];
    private _totalWin: number = -1;
    private _buyFeatureName: string = "";

    constructor() {
        this.addEventListeners();
    }

    public isWinBelowStake(): boolean {
        return SlotGame.api.gameClientConfiguration.belowStakeWinRestriction && (this.getAccumulatedRoundWin() <= this.getBuyFeaturePrice());
    }

    public reset(): void {
        this.wasFeatureBuy = false;
        this._buyFeatureName = "";
    }

    private addEventListeners(): void {
        SlotGame.api.events.once("featureBet", (data: boolean) => this.wasFeatureBuy = data);
        SlotGame.api.events.once("featureName", (data: string) => this._buyFeatureName = data);
        SlotGame.api.events.on(APIEvent.BET, (betData: APIFeatureBetEventData) => {
            for (let index: number = 0; index < this._featureBuyTimesBetValue.length; index++) {
                if (this._featureBuyTimesBetValue[index].name === betData.featureName) {
                    this._buyFeatureName = betData.featureName;
                    break;
                }
            }
        });

        SlotGame.api.events.on(APIEvent.ACTION_SPINS_BET, (betData: APIFeatureBetEventData) => {
            for (let index: number = 0; index < this._featureBuyTimesBetValue.length; index++) {
                if (this._featureBuyTimesBetValue[index].name === betData.featureName) {
                    this._buyFeatureName = betData.featureName;
                    break;
                }
            }
        });

        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event: GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event: GameEvent) => this.onGameDataParsed(event.params[0]));
    }

    private onInitDataParsed(data: SanParsedInitData): void {
        this._featureBuyTimesBetValue = data.featureBuyTimesBetValue;
        this._totalWin = data.totalWin;
        EventHandler.removeEventListener(this, ServerEvent.INIT_DATA_PARSED);
    }

    private onGameDataParsed(data: SanParsedGameData): void {
        this._totalWin = data.totalWin;
    }

    private getBuyFeaturePrice(): number {
        const betLevel: string = SlotGame.api.freeBets.hasFreeBets() ? SlotGame.api.freeBets.getBet() : SlotGame.api.betLevel.getLevel();
        let price: number = SlotGame.model.gameData?.playedBetValue || parseFloat(betLevel);
        if (this.wasFeatureBuy) {
            for (let index: number = 0; index < this._featureBuyTimesBetValue.length; index++) {
                if (this._featureBuyTimesBetValue[index].name === this._buyFeatureName) {
                    price *= this._featureBuyTimesBetValue[index].price;
                    break;
                }
            }
        }
        return price;
    }

    public getFeaturePrice(): number {
        const betLevel: string = SlotGame.api.freeBets.hasFreeBets() ? SlotGame.api.freeBets.getBet() : SlotGame.api.betLevel.getLevel();
        let price: number = SlotGame.model.gameData?.playedBetValue || parseFloat(betLevel);
        for (let index: number = 0; index < this._featureBuyTimesBetValue.length; index++) {
            if (this._featureBuyTimesBetValue[index].name === this._buyFeatureName) {
                price *= this._featureBuyTimesBetValue[index].price;
                break;
            }
        }
        return price;
    }

    private getAccumulatedRoundWin(): number {
        return this._totalWin;
    }
}